import styled from 'styled-components';
import { ReactComponent as ArrowImage } from './images/arrow.svg';

export const Container = styled.div`
  position: relative;
  background-color: white;
  width: 1424px;

  > div:nth-of-type(2) {
    margin-bottom: 48px;

    > div:last-of-type {
      display: flex;
      flex-direction: column;
      gap: 6px;
    }
  }

  > div:nth-of-type(3) {
    width: 1140px;

    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 48px;
    justify-content: space-around;
  }
`;

export const Legend = styled.div<{opened?: boolean}>`
  display: flex;
  align-items: center;
  gap: 20px;

  padding: 6px;
  border-radius: 5px;
  background-color: #fff9;
  border: 1px solid #0003;

  position: fixed;
  
  ${(p) => p.opened ? 'right: 10px;' : 'right: -255px;'}

  transition: right 0.3s ease-in-out;

  z-index: 10;

  > div {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
`;

export const Arrow = styled(ArrowImage).withConfig({
  shouldForwardProp: (prop) => !['opened'].includes(prop as string),
})<{opened?: boolean}>`
  width: 20px;
  height: 20px;

  cursor: pointer;

  ${(p) => p.opened ? 'transform: rotate(180deg);' : ''}
`;
